import { jsx, jsxs } from 'react/jsx-runtime';
import { Menu } from './Menubar/index.js';
import { Navbar } from './Navbar/index.js';
import { SCHeaderContainer, SCHeaderContentContainer, SCLogoContainer, SCLink, SCBarContainer } from './styles.js';
const MyEmpowerHeader = () => {
  return /* @__PURE__ */jsx(SCHeaderContainer, {
    children: /* @__PURE__ */jsxs(SCHeaderContentContainer, {
      children: [/* @__PURE__ */jsx(SCLogoContainer, {
        children: /* @__PURE__ */jsx(SCLink, {
          noHoverColor: true,
          href: "/",
          children: "MyEmpower"
        })
      }), /* @__PURE__ */jsxs(SCBarContainer, {
        children: [/* @__PURE__ */jsx(Menu, {}), /* @__PURE__ */jsx(Navbar, {})]
      })]
    })
  });
};
export { MyEmpowerHeader as default };